import React, { Component } from 'react';

import 'css/components/developers/docs/api/_APIDocsBlock.scss';

export default class APIDocsBlock extends Component {
  static propTypes = {};

  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <div className="apiDocsBlock">
        <div className="wordDocumentation">{this.props.children[0]}</div>
        <div className="codeDocumentation">{this.props.children[1]}</div>
      </div>
    );
  }
}
